<div class="auto">
  <input
    type="text"
    class="auto__input"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-expanded]="abierto()"
    [placeholder]="placeholder()"
    [value]="texto()"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (keydown)="onKeydown($event)"
  />

  @if (abierto()) {
    <ul class="auto__lista" #lista role="listbox">
      @if (buscando()) {
        <li class="auto__estado">Buscando…</li>
      } @else if (!opciones().length) {
        <li class="auto__estado">Sin resultados</li>
      } @else {
        <!-- Homónimas de distinta provincia comparten `value` (el slug) pero
             no `label`: trackear sólo por `value` repetía claves (NG0955). -->
        @for (
          opcion of opciones();
          track opcion.value + opcion.label;
          let i = $index
        ) {
          <!-- preventDefault en mousedown: sin esto el blur del input cierra
               la lista antes de que llegue el click. -->
          <li
            class="auto__opcion"
            [class.auto__opcion--destacada]="i === destacada()"
            role="option"
            [attr.aria-selected]="i === destacada()"
            (mousedown)="$event.preventDefault()"
            (click)="seleccionar(opcion)"
          >
            <span class="auto__nombre">{{ opcion.nombre }}</span>
            @if (opcion.detalle) {
              <span class="auto__detalle">{{ opcion.detalle }}</span>
            }
          </li>
        }
      }
    </ul>
  }
</div>
